var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonegoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.0703,
    r: 12,
    fill: "#0D3470",
    stroke: "#0D3470",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4853 17.8007C11.354 17.801 11.224 17.7753 11.1026 17.7252C10.9813 17.6751 10.8711 17.6015 10.7783 17.5087L6.53626 13.2657C6.44068 13.1735 6.36442 13.0632 6.31193 12.9413C6.25944 12.8193 6.23176 12.6881 6.23051 12.5553C6.22927 12.4225 6.25448 12.2908 6.30467 12.1679C6.35486 12.045 6.42904 11.9333 6.52286 11.8393C6.61669 11.7454 6.72829 11.671 6.85115 11.6207C6.974 11.5703 7.10566 11.5449 7.23844 11.546C7.37122 11.547 7.50246 11.5745 7.6245 11.6268C7.74654 11.6792 7.85694 11.7553 7.94926 11.8507L11.4843 15.3857L17.8493 9.02269C18.0368 8.83505 18.2911 8.72959 18.5564 8.72949C18.8217 8.7294 19.0761 8.83469 19.2638 9.02219C19.4514 9.2097 19.5569 9.46407 19.557 9.72934C19.5571 9.99461 19.4518 10.2491 19.2643 10.4367L12.1923 17.5087C12.0994 17.6015 11.9892 17.6751 11.8679 17.7252C11.7465 17.7753 11.6165 17.801 11.4853 17.8007Z",
    fill: "#FDFBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonegoal);
export default __webpack_public_path__ + "static/media/donegoal.f222d7bd235cde3ae22ad656308c83ec.svg";
export { ForwardRef as ReactComponent };